
/**
 * Module dependencies.
 */

import { combineReducers } from 'redux'
import catalog from './catalog'
import forgot from './forgot'
import reset from './reset'
import setup from './setup'
import warehouseSetup from './warehouse-setup'
import audiences from './audiences'
import features from './features'
import lockouts from './lockouts'
import sourceUpgrades from './source-upgrades'
import workspaceActivity from './workspace-activity'
import workspaceSettings from './workspace-settings'
import sourcesCatalog from './sources-catalog'
import sourcesList from './sources-list'
import warehouseSettings from './warehouse-settings'
import workspacesSourcesIntegrations from './workspaces-sources-integrations'
import sourceSetup from './source-setup'
import simulator from './simulator'
import page from './page'
import rules from './rules'
import app from './app'
import churnSurvey from './churn-survey'
import sourceIntegrations from './source-integrations'
import customers from './customers'

/**
 * Export combined reducers.
 */

export default combineReducers({
  catalog,
  setup,
  forgot,
  reset,
  warehouseSetup,
  workspaceActivity,
  audiences,
  features,
  lockouts,
  sourceUpgrades,
  workspaceSettings,
  sourcesCatalog,
  sourcesList,
  warehouseSettings,
  workspacesSourcesIntegrations,
  sourceSetup,
  simulator,
  currentWorkspaceSlug: (state = null) => state,
  page,
  rules,
  app,
  churnSurvey,
  sourceIntegrations,
  customers
})



// WEBPACK FOOTER //
// ./reducers/application/index.js